import { useQueryApi, useMutationApi } from 'utils/api'
import {
  handleError,
  validateStatus,
} from 'api/kinerja/pengawas-sekolah/config'
import { apiPaths, queryKeys } from './config'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { ResponseGetNotificationList } from 'types/kinerja-ps-pegawai'
import type { UseMutationOptions, UseQueryOptions } from 'react-query'

export function useAPIGetPSPegawaiNotificationList(
  options: UseQueryOptions<ResponseGetNotificationList> = {}
) {
  const { period } = usePeriodContext()

  return useQueryApi<ResponseGetNotificationList>(
    `${apiPaths.notification}/list`,
    {
      queryKey: [queryKeys.API_GET_NOTIFICATION_LIST, period.id],
      axiosConfig: {
        validateStatus,
      },
      queryConfig: {
        useErrorBoundary: true,
        ...options,
      },
      errorHandlerFn: handleError,
    }
  )
}

export function useAPIMarkAllPSPegawaiNotificationsAsRead(
  opts?: UseMutationOptions<unknown, Error, {}>
) {
  return useMutationApi(`${apiPaths.notification}/read`, {
    axiosConfig: {
      method: 'PATCH',
    },
    mutationConfig: {
      ...opts,
    },
  })
}
